import { PageContainer } from '~/components/elements/PageContainer/PageContainer';
import styles from './style.module.css';
import React from 'react';

export const ErrorRequireRestart: React.FC = () => {
  return (
    <PageContainer title="最初からやり直してください。" hideHeader>
      <div className={styles.message}>
        処理の継続に必要な情報がみつかりませんでした。 お手数ですが、最初から再度お試しください。
      </div>
    </PageContainer>
  );
};
